import { useMutation } from '@apollo/client';
import { EventFormFields } from 'components/eventView/eventForm/EventFormFields';
import { EventFormSubmitted } from 'components/eventView/eventForm/EventFormSubmitted';
import { EEventForm } from 'graphql/fragment/__generated__/EEventForm';
import { SubmitForm, SubmitFormVariables } from 'graphql/mutation/__generated__/SubmitForm';
import { E_SUBMIT_FORM_MUTATION } from 'graphql/mutation/guideMutation';
import { useContext, useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    form: EEventForm;
}

export const EVFormPageContent = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const FORM_SUBMITTED_KEY = 'guide_formSubmitted_' + props.form.eventFormId;
    const [isSubmitted, setIsSubmitted] = useLocalStorage(FORM_SUBMITTED_KEY, false);

    const [sendSubmitFormMutation, submitFormMutation] = useMutation<
        SubmitForm,
        SubmitFormVariables
    >(E_SUBMIT_FORM_MUTATION);

    function onSubmit(data: Record<string, unknown>) {
        sendSubmitFormMutation({
            variables: {
                eventFormId: props.form.eventFormId,
                eventId: ctxEventView.eventData.eventId,
                data
            },
            onCompleted: () => {
                setIsSubmitted(true);
            }
        });
    }

    useEffect(() => {
        ctxEventView.setScrollToTop(true);
    }, []);

    return (
        <S_EVProgramPageContent className={props.className}>
            {isSubmitted && <EventFormSubmitted onReset={() => setIsSubmitted(false)} />}
            {!isSubmitted && (
                <EventFormFields
                    guideId={ctxEventView.eventData.eventId}
                    formFields={props.form.fields}
                    isLoading={submitFormMutation.loading}
                    onSubmitValidationError={() => {
                        ctxEventView.setScrollToTop(true);
                    }}
                    onSubmit={onSubmit}
                />
            )}
        </S_EVProgramPageContent>
    );
};

const S_EVProgramPageContent = styled.div``;
